import { SubLayout } from "@/containers/layout/LandingLayout";
import { FC } from "react";

const JoinUs: FC = (): JSX.Element => {
  return (
    <SubLayout allowOverflow>
      <section className="relative z-30 flex flex-col items-center justify-center w-full mx-auto text-white -top-10 md:top-auto md:mt-0 xl:top-0 py-9 px-7 md:h-40 xl:h-60 rounded-2xl p-14 bg-landing-denim">
        <h2 className="text-3xl font-bold text-center xl:text-5xl max-w-[22.5rem] md:max-w-fit mb-4">
          Join us on our mission
        </h2>

        <div className="flex flex-col items-center justify-center text-center xl:flex-row">
          <p className="font-serif text-xl font-normal md:my-auto xl:text-2xl">
            Help us create meaningful, lasting change for homebuyers in the UK.
          </p>

          <p className="font-serif text-xl font-normal md:my-auto xl:text-2xl xl:ml-2">
            Email:{" "}
            <span className="border-b">
              <a href="mailto:careers@keyzy.com" target="_blank" rel="noreferrer">
                careers@keyzy.com
              </a>
            </span>
          </p>
        </div>

        <div className="hidden xl:inline-block md:w-16 xl:w-32 absolute md:top-10 xl:top-12 md:-left-2 xl:-left-5 z-10 bg-landing-blue h-[2px]" />
        <div className="hidden xl:inline-block  md:w-12 xl:w-56 absolute  md:top-14 xl:top-20 md:-left-6   xl:-left-40 bg-landing-blue h-[2px]" />
        <div className="hidden xl:inline-block w-28 absolute xl:top-12 -right-14 bg-landing-blue h-[2px]" />
        <div className="hidden xl:inline-block w-28 absolute xl:top-20 -right-6 bg-landing-blue h-[2px]" />
      </section>
    </SubLayout>
  );
};

export default JoinUs;
